import { phoneStateSchema, phoneStatesSchema } from "./schema";
import { getEntity, getEntities } from "./base";

const path = "/portal/api/phone_states";

const getPhoneState = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, phoneStateSchema);
};

const getPhoneStates = (clientConfig, dataStatus) => {
  return getEntities(clientConfig, dataStatus, path, phoneStatesSchema);
};

export { getPhoneState, getPhoneStates };
